import { Action } from '@ngrx/store';
import { SearchSettings } from '../../../../app/shared/models/b2b/searchSettings';

export enum FilterTopActionTypes {
    DO_SET_LIST_TYPE = '[FilterTop] Set List Type',
    DO_SET_SETTINGS = '[FilterTop] Set Settings',
    // DO_CLEAR = '[FilterTop] Do Clear'
}

// List Type
export class DoSetListType implements Action {
    readonly type = FilterTopActionTypes.DO_SET_LIST_TYPE;
    constructor(public payload: { listType: any }) {}
}

// List Settings
export class DoSetSettings implements Action {
    readonly type = FilterTopActionTypes.DO_SET_SETTINGS;
    constructor(public payload: { settings: SearchSettings }) {}
}

// Clear
// export class DoClear implements Action {
//     readonly type = FilterTopActionTypes.DO_CLEAR;
//     constructor() { }
// }

export type FilterTopActions = DoSetListType | DoSetSettings;
